import React, { useContext } from 'react';
import styles from './reviewSearchAndKeywordsStyles.module.scss';
import { MUI_MOBILE_BREAKPOINT } from 'src/scripts/utils/constants';
import { useMediaQuery } from 'usehooks-ts';
import { ProductReviewContext } from '../ProductReviewContext';

const ReviewAIKeywords = ({
  keywords,
  activeKeyword,
  setActiveKeyword,
  disableShowMore = false,
}: {
  keywords: string[] | null;
  activeKeyword: string | undefined;
  setActiveKeyword: React.Dispatch<React.SetStateAction<string | undefined>>;
  disableShowMore?: boolean;
}) => {
  const { toggleProductReviewFiltersDrawer, setActiveReviewFilterAccordion } = useContext(ProductReviewContext);

  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT);

  const toggleActive = (keyword: string) => {
    setActiveKeyword((prev) => (prev === keyword ? '' : keyword));
  };

  const visibleKeywords = !isMobile || disableShowMore ? keywords : keywords?.slice(0, 2);
  const hasMore = keywords && keywords.length > 2;

  if (!keywords || keywords.length === 0) {
    return null;
  }
  return (
    <ul className={styles.reviewAIKeywords}>
      {visibleKeywords?.map((keyword) => (
        <li key={keyword}>
          <button
            onClick={() => toggleActive(keyword)}
            className={`${styles.keywordButton} button-toggle${activeKeyword === keyword ? ' active' : ''} notranslate`}
          >
            {keyword}
          </button>
        </li>
      ))}
      {isMobile && hasMore && !disableShowMore && (
        <li>
          <button
            onClick={() => {
              toggleProductReviewFiltersDrawer(true);
              setActiveReviewFilterAccordion('keywords');
            }}
            className={`${styles.showMoreButton} button-toggle`}
          >
            ...
          </button>
        </li>
      )}
    </ul>
  );
};

export default ReviewAIKeywords;
